export default "<div class=\"mat-mini-fab mat-accent\" matTooltip=\"{{tooltip}}\" (click)=\"cancel()\">\r\n    <i class=\"fas fa-times\"></i>\r\n</div>\r\n"